import React from 'react';
import { LanguageList } from '@udemy/language-selector';
import { LanguageSelectorLocation } from '../../../constants';
import styles from "./language-selector-overlay.module.css";
export const LanguageSelectorOverlay = ({
  useLangPrefixedUrls = false
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement(LanguageList, {
    uiRegion: LanguageSelectorLocation.MOBILE_NAV,
    useLangPrefixedUrls: useLangPrefixedUrls
  }));
};
//# sourceMappingURL=language-selector-overlay.react-component.js.map